import React from 'react'
import HeaderMiniApp from './HeaderMiniApp'
import './index.scss'
export default function IframeMiniApp({ urlIframe, title = 'Tư vấn', onClose }) {
  return (
    <div className="IframeMiniApp">
      <HeaderMiniApp position="relative" title={title} goBack={onClose} shouldPrioritizeGoBack={true} />
      <iframe
        key={urlIframe}
        src={urlIframe}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="IframeMiniApp"
      />
    </div>
  )
}
